import { render, staticRenderFns } from "./Product5.vue?vue&type=template&id=4b8b23ee&scoped=true&"
import script from "./Product5.vue?vue&type=script&lang=js&"
export * from "./Product5.vue?vue&type=script&lang=js&"
import style0 from "./Product5.vue?vue&type=style&index=0&id=4b8b23ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b23ee",
  null
  
)

export default component.exports